import axios from 'axios';
import { API_URL } from '../config';
interface LoginCredentials {
  username: string;
  password: string;
}

interface AuthResponse {
  access_token: string;
  token_type: string;
}

export const AuthService = {
  normalizeRole: (role: string | null): string | null => {
    if (!role) return null;
    switch (role) {
      case 'HUB_READONLY':
      case 'HUB_VIEWER':
        return 'USER_HUB';
      case 'CLIENT_ADMIN':
        return 'USER_CLIENT_ADMIN';
      case 'CLIENT_USER':
      case 'USER':
        return 'USER_CLIENT';
      default:
        return role;
    }
  },

  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    try {
      // Convertendo as credenciais para o formato x-www-form-urlencoded
      const formData = new URLSearchParams();
      formData.append('username', credentials.username);
      formData.append('password', credentials.password);
      formData.append('grant_type', 'password'); // Adicionando grant_type

      console.log('Tentando login com:', credentials.username);
      const response = await axios.post(`${API_URL}/auth/token`, formData, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json'
        }
      });
      
      if (response.data && response.data.access_token) {
        const { access_token, token_type } = response.data;
        console.log('Token recebido:', access_token);
        console.log('Tipo do token:', token_type);
        
        // Armazenando o token e informações do usuário
        localStorage.setItem('access_token', access_token);
        localStorage.setItem('token_type', token_type);
        localStorage.setItem('isAuthenticated', 'true');
        
        // Buscando informações do usuário
        try {
          console.log('Buscando informações do usuário...');
          const userResponse = await axios.get(`${API_URL}/auth/user/me`, {
            headers: {
              'Authorization': `Bearer ${access_token}`
            }
          });
          
          console.log('Resposta do usuário:', userResponse.data);
          if (userResponse.data) {
            const normalizedRole = AuthService.normalizeRole(userResponse.data.role);
            if (normalizedRole) {
              localStorage.setItem('userRole', normalizedRole);
              console.log('Role do usuário:', normalizedRole);
            }
            if (userResponse.data.username) {
              localStorage.setItem('username', userResponse.data.username);
            }
            if (userResponse.data.full_name) {
              localStorage.setItem('fullName', userResponse.data.full_name);
            }
            if (userResponse.data.email) {
              localStorage.setItem('userEmail', userResponse.data.email);
            }
            if (userResponse.data.phone) {
              localStorage.setItem('userPhone', userResponse.data.phone);
            }
          }
        } catch (error) {
          console.error('Error fetching user info:', error);
          if (axios.isAxiosError(error)) {
            console.error('Status:', error.response?.status);
            console.error('Data:', error.response?.data);
          }
        }
        
        return response.data;
      } else {
        throw new Error('Token não recebido na resposta');
      }
    } catch (error) {
      console.error('Login error:', error);
      if (axios.isAxiosError(error)) {
        console.error('Status:', error.response?.status);
        console.error('Data:', error.response?.data);
      }
      throw error;
    }
  },

  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('token_type');
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userRole');
    localStorage.removeItem('username');
    localStorage.removeItem('fullName');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userPhone');
    window.location.href = '/login';
  },

  isAuthenticated: (): boolean => {
    const token = localStorage.getItem('access_token');
    const isAuth = localStorage.getItem('isAuthenticated') === 'true';
    console.log('Token no localStorage:', token);
    console.log('isAuthenticated:', isAuth);
    return !!token && isAuth;
  },

  getToken: (): string | null => {
    const token = localStorage.getItem('access_token');
    console.log('getToken retornando:', token);
    return token;
  },

  getUserRole: (): string | null => {
    const stored = localStorage.getItem('userRole');
    return AuthService.normalizeRole(stored);
  },

  getUsername: (): string | null => {
    return localStorage.getItem('username');
  },

  getFullName: (): string | null => {
    return localStorage.getItem('fullName');
  },

  isAdmin: (): boolean => {
    return AuthService.getUserRole() === 'ADMIN';
  },

  canCreateNotifications: (): boolean => {
    const role = AuthService.getUserRole();
    return role === 'ADMIN' || role === 'USER_CLIENT_ADMIN' || role === 'USER_CLIENT';
  }
}; 
